import { render, staticRenderFns } from "./DashBoardSettingsView.vue?vue&type=template&id=073674f0&scoped=true&"
import script from "./DashBoardSettingsView.vue?vue&type=script&lang=js&"
export * from "./DashBoardSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardSettingsView.vue?vue&type=style&index=0&id=073674f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073674f0",
  null
  
)

export default component.exports